document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('themeToggleBtn');
  if (!btn) return;

  btn.addEventListener('click', function () {
    var current = document.documentElement.getAttribute('data-theme');
    var next = current === 'light' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', next);
    localStorage.setItem('site-theme', next);
  });
});